module.exports = __webpack_public_path__ + "static/media/groupme.8b259d07.png";